export { default as List } from 'catalogs/containers/CatalogsListContainer';
export { default as Form } from 'catalogs/containers/CatalogsFormContainer';



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/containers/index.js